'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';

export function AvatarImageView(props) {
  return (
    <div className={classNames('Avatar', props.className)}>
      {props.children
        ? props.children
        : (
          <div
            className={classNames(props.iconClass, {
              'long-initials': (props.avatarText || '').length > 2,
            })}
            style={AvatarImageView.getInitialsStyle(props.avatarColor, props.avatarFontColor)}
            title={props.title}
          >
            {props.avatarText}
          </div>
        )
      }
    </div>
  );
}

AvatarImageView.propTypes = {
  className: T.string,
  iconClass: T.string,
  title: T.string,
  avatarText: T.string,
  avatarColor: T.string,
  avatarFontColor: T.string,
};

AvatarImageView.defaultProps = {
  iconClass: 'Avatar__icon',
};

AvatarImageView.getInitialsStyle = (backgroundColor, color) => ({
  backgroundColor,
  color,
});



// WEBPACK FOOTER //
// ./src/js/files/components/AvatarImage/AvatarImageView.js